import axios from 'axios'


export function postRequest(functionName,params) {
  return axios.post('./index.php', {
      function: functionName,
      ...params
    })
    .then(function (response) {
      return response.data
    })
    .catch(function (error) {
      console.log(error);
    })
}
